import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="feature-toggle"
export default class extends Controller {
  static targets = ["button", "hiddenContent"]
  static values = { section: String }

  connect() {
    this.isExpanded = false
    this.originalButtonText = this.buttonTarget.innerHTML
  }

  toggle() {
    if (!this.isExpanded) {
      this.showFeatures()
    } else {
      this.hideFeatures()
    }
  }

  showFeatures() {
    // Show hidden features with animation
    this.hiddenContentTarget.style.display = 'grid'

    // Force reflow before adding animation class
    this.hiddenContentTarget.offsetHeight

    // Add animation class
    setTimeout(() => {
      this.hiddenContentTarget.classList.add('show')
    }, 10)

    // Update button
    this.buttonTarget.innerHTML = 'Show Less</span>'
    this.buttonTarget.classList.add('expanded')
    this.isExpanded = true

    // Smooth scroll to ensure visibility
    setTimeout(() => {
      this.hiddenContentTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      })
    }, 100)
  }

  hideFeatures() {
    // Hide features with animation
    this.hiddenContentTarget.classList.remove('show')

    // Wait for animation to complete before hiding
    setTimeout(() => {
      this.hiddenContentTarget.style.display = 'none'
    }, 500)

    // Reset button
    this.buttonTarget.innerHTML = 'Show More'
    this.buttonTarget.classList.remove('expanded')
    this.isExpanded = false

    // Scroll back to the button for better UX
    setTimeout(() => {
      this.buttonTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    }, 100)
  }

  // Cleanup when controller disconnects
  disconnect() {
    if (this.hiddenContentTarget) {
      this.hiddenContentTarget.style.display = 'none'
      this.hiddenContentTarget.classList.remove('show')
    }

    if (this.buttonTarget && this.originalButtonText) {
      this.buttonTarget.innerHTML = this.originalButtonText
      this.buttonTarget.classList.remove('expanded')
    }
  }
}